import { useQuery, useMutation } from 'react-query'
import axios from 'axios'

const ENDPOINT = '/api/promotions/end-user/scratch-card-redemptions'
const QUERY_KEY = 'scratch-card-redemption'

export const useGetEndUserScratchCards = (params = {}, config = {}) =>
  useQuery(
    [`${QUERY_KEY}s`, params],
    async () => (await axios.get(ENDPOINT, { params })).data,
    config
  )

export const useGetEndUserScratchCardById = (id, config = {}) =>
  useQuery([QUERY_KEY, id], async () => (await axios.get(`${ENDPOINT}/${id}`)).data, config)

export const useGetEndUserScratchCardCanSubmit = (config = {}) =>
  useQuery(
    [QUERY_KEY, 'form', 'can-submit'],
    async () => (await axios.get(`${ENDPOINT}/form/can-submit`)).data,
    config
  )

export const usePostEndUserScratchCard = (config = {}) =>
  useMutation((newData) => axios.post(ENDPOINT, newData), config)

export const usePostExportEndUserScratchCard = (config = {}) =>
  useMutation(() => axios.post(`${ENDPOINT}/export`, null, { responseType: 'blob' }), config)

export const usePostResendSMSEndUserScratchCard = (id, config = {}) =>
  useMutation((data) => axios.post(`${ENDPOINT}/${id}/resend-sms`, null), config)

export const usePatchEndUserScratchCardApprove = (id, config = {}) =>
  useMutation((updatedData) => axios.patch(`${ENDPOINT}/${id}/approve`, updatedData), config)

export const usePatchEndUserScratchCardReject = (id, config = {}) =>
  useMutation((updatedData) => axios.patch(`${ENDPOINT}/${id}/reject`, updatedData), config)
